import { History } from 'history'
import { inject, observer, Provider } from 'mobx-react'
import * as React from 'react'
import { Match, withRouter } from 'react-router-dom'
import { APIService, IAPIService } from '../../shared/APIService'
import { styled } from '../../shared/styled-components'
import { FontsCSS } from '../../shared/styles/FontsCSS'
import { ResetCSS } from '../../shared/styles/ResetCSS'
import { Utils } from '../../shared/Utils'
import { CalculatorStore, CalculatorStoreInstance } from '../../stores/CalculatorStore'
import { CalculatorOptions } from '../calculator'
import { Routes, SubRoutesDefinition } from '../Routes'
import { Footer } from './Footer'
import Progress from './Progress'
import { VideoOverlay } from './VideoOverlay'

interface IProps {
  history?: History
  match?: Match
  store?: CalculatorStoreInstance
  options?: CalculatorOptions
}

@(withRouter as any)
@inject('options')
@observer
export default class Calculator extends React.Component<IProps> {
  private _api: IAPIService = new APIService()
  private _store: CalculatorStoreInstance = CalculatorStore.create({
    offer: {},
    offices: []
  }, {
    history: this.props.history!,
    api: this._api,
    options: this.props.options
  })

  // -------------------------------------------------------------------------- LIFECYCLE

  componentDidMount () {
    if (window.location.pathname.replace(/\/$/, '') === '/implantatkostenrechner') {
      this._store.redirectToRoute(Routes.calculatorUpperJaw)
    }
  }

  // -------------------------------------------------------------------------- RENDERING

  render(): React.ReactNode {
    const { pathname } = window.location
    return (<Provider store={this._store} api={this._api}>
      <Container className='implacheckCalculator'>
        <ResetCSS />
        <FontsCSS />

        {pathname.indexOf('ergebnis') === -1 && pathname.indexOf('praxen') === -1 && <Progress />}
        {Utils.renderRoutes(Routes as unknown as SubRoutesDefinition)}
        {this._store.videoVisible && <VideoOverlay />}

        <Footer />
      </Container>
    </Provider>)
  }
}

const Container = styled.div`
  font-family: ${props => props.theme.textFont};
  font-weight: ${props => props.theme.textWeight};
  color: ${props => props.theme.textColor};
`
